class SizeChartTable extends HTMLElement {
    constructor() {
        super();
        this.currentUnit = 'in';
    }

    connectedCallback() {
        this.navigationButtons = this.querySelectorAll('[size-chart-button]');
        this.convertableCells = this.querySelectorAll('[convertable-data-cell]');

        this.navigationButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                this.convertValues(e.target);
                this.toggleButtonState(e.target);
            });
        });
    }


    toggleButtonState(targetButton) {
        this.navigationButtons.forEach(button => {
            button.removeAttribute('active');
        });

        targetButton.setAttribute('active', '');
    }

    convertValues(target) {
        const targetUnit = target.getAttribute('size-chart-button');
        if (this.currentUnit == targetUnit) return;

        this.convertableCells.forEach(cell => {
            let cellData = parseFloat(cell.getAttribute('convertable-data-cell'));
            if (isNaN(cellData)) return;

            let convertedValue;
            if (targetUnit === 'cm') {
                convertedValue = cellData * 2.54;
            } else {
                convertedValue = cellData / 2.54;
            }

            convertedValue = Math.round(convertedValue * 20) / 20;

            let formattedValue;
            if (Number.isInteger(convertedValue)) {
                formattedValue = convertedValue.toFixed(1);
            } else if (convertedValue * 10 % 1 === 0) {
                formattedValue = convertedValue.toFixed(1);
            } else {
                formattedValue = convertedValue.toFixed(2);
            }

            cell.setAttribute('convertable-data-cell', formattedValue);
            cell.textContent = targetUnit === 'cm'
                ? formattedValue
                : formattedValue + '"';
        });

        this.currentUnit = targetUnit;
    }


}

customElements.define('size-chart-table', SizeChartTable);

class ScrollTipManager {
    constructor() {
        this.observedElements = new Set();
        this.observer = null;
        this.init();
    }

    init() {
        this.observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(({ target, isIntersecting }) => {
                if (!isIntersecting || this.observedElements.has(target)) return;

                this.observedElements.add(target);
                this.startScrollTip(target);
                obs.unobserve(target);
            });
        }, { threshold: 0.1 });

        this.observeElements();
    }

    observeElements() {
        document.querySelectorAll('[data-scroll-tip]').forEach(el => {
            this.observer.observe(el);
        });
    }

    startScrollTip(element) {
        const axes = element.dataset.scrollTip || '';
        const doX = axes.includes('x');
        const doY = axes.includes('y');

        if (doX && element.scrollWidth > element.clientWidth) {
            setTimeout(() => this.createScrollTip(element, 'x'), 1000);
        }
        if (doY && element.scrollHeight > element.clientHeight) {
            setTimeout(() => this.createScrollTip(element, 'y'), 1000);
        }
    }

    createScrollTip(element, axis) {
        const scrollTip = new ScrollTip(element, axis);
        scrollTip.start();
    }
}
